module.exports = __webpack_public_path__ + "img/photo12.f3ed9903.jpg";